import { getToken } from "../auth/getToken";
import { appConfig } from "../appConfig";
import { getTrustLoginHint } from "../trust/trustLoginHint";
import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { TRUST_PATHS } from "../trust/paths";

type ExtraInfo = { loggedFrom?: string };
type LogPayload = {
  userAgent: string;
  href: string;
  error: unknown;
  date: Date;
  extraInfo?: ExtraInfo;
};

export const logError = async (error: LogPayload["error"], extraInfo?: ExtraInfo) => {
  console.error(error);

  const isTrust = location.pathname.startsWith(TRUST_PATHS.base);
  if (isTrust) {
    const isTrustLoggedIn = getTrustLoginHint();
    if (isTrustLoggedIn)
      log(`${appConfig.env.API_URL}/novatrust/v1/log/client-error`, {
        error,
        extraInfo,
        options: { credentials: "include" },
      });
    return null;
  }

  const headers: Record<string, string> = { Authorization: `Bearer ${getToken()}` };

  log(`${FORMS_API_BASE_ENDPOINT}/log/client-error`, { error, extraInfo, options: { headers } });
  return null;
};

const log = (
  endpoint: string,
  {
    error,
    extraInfo,
    options,
  }: {
    error: LogPayload["error"];
    extraInfo?: ExtraInfo;
    options: RequestInit;
  }
) => {
  const payload: LogPayload = {
    href: location.href,
    error: `${JSON.stringify(error, Object.getOwnPropertyNames(error))}${extraInfo ? ` Extra info: ${JSON.stringify(extraInfo)}` : ""}`,
    userAgent: window.navigator.userAgent,
    date: new Date(),
    extraInfo,
  };

  fetch(endpoint, {
    method: "POST",
    body: JSON.stringify(payload),
    keepalive: true,
    ...options,
    headers: { "Content-Type": "application/json", ...options.headers },
  }).catch(() => {});
};

export const logUnhandled = (value: never, context: string) => {
  logError(new Error(`Unhandled ${context}: ${JSON.stringify(value)}`));
  return null;
};
